/**
 * Created by Wang on 2021/4/15.
 */

import tools from '../../tools'
import expoolExercise from "./../../components/expoolExercise/expoolExercise.vue";
import Chapter from "./../../components/Chapter/Chapter.vue";

let token = tools.getCookie('localtoken');
var indent = '\t'; //tab
export default {
    name: 'expool',
    watch: {
        //如果路由发生了变化，更新页面数据
        $route(to, from) {
            if (to.path !== from.path) {
                if (this.exercisePoolId != this.$route.params.exercisePoolId) {
                    this.exercisePoolId = this.$route.params.exercisePoolId;
                    this.jing = this.$route.params.jing;
                    this.Statu = this.$route.params.Statu;
                    this.init();
                }
            }
        }
    },
    components: {
        Chapter: Chapter,
        expoolExercise: expoolExercise,
    },
    data() {
        return {
            subjectCourse:'',
            exercisePoolId: this.$route.params.exercisePoolId,
            jing:this.$route.params.jing,
            Statu:this.$route.params.Statu,
            exercisePoolName: "",
            exercisePoolExcount: 0,
            Genre: -1, // 题库类型
            activeChapterId: 0, //0是目录，有值是章节id
            isOCRExercisePool: true,
            isNothing: false, //空内容

            IsEditor: false, //是否能编辑
            activeChapterName: "",
            //图片页码状态
            reviewPictureTotalCount: 0, //图片总数量
            reviewPictureCount: 0, //已标注图片数量
            answerPictureList: [], //答案页页码和状态
            exercisePictureList: [], //习题页页码和状态
            repeatPageCount: 0, //重复页数量

            isEditorCatalog: false, //是否编辑目录状态
            catalogPictureList: [], //目录页
            catalogPictureActiveIndex: 0, //当前项

            //章节下的图片
            chapterViewType: 0, //0-图片视图，1-习题视图
            chapterPictureList: [],
            chapterPictureActiveIndex: 0, //当前项
            selectChapterPictureList: [], //选中集合

            //图片异常
            isImgAbnormal: false, //是否图片一场
            isShowImgAbnormalModal: false, //是否显示错误提示
            imgAbnormalModalTimeout: {}, //错误提示计时器

            //图片放大
            enlargeList: ["50%", "75%", "100%", "125%", "150%", "175%", "200%"],
            enlargeIndex: 2,
            serachTxt:'',//搜索条件
            isSearch:false,
            voiceid:'', //选中的音频
            voiceareashow:false,
            allvoiceList:[],//所有音频资源列表
            nowchiceChapter:'',
            dialogVisible:false,
            fromBeike: false
        }
    },
    created() {
        let that = this;
        that.init();
        this.$emit("header", false);
        this.$emit("footer", false);
        let routeParams = tools.$_GET()
        if(routeParams.source != undefined) {
            this.fromBeike = true
        }
    },
    mounted: function () {
    },
    updated: function () {

    },
    methods: {
        init: function () {
            let _this = this;
            _this.getExercisePool();
            _this.checkEditor();
            _this.getPictureCountByExercisePool();
        },
        //获取题库
        getExercisePool: function () {
            let _this = this;
            tools.api('ExercisesPool.GetExercisePoolByIdAsync', {"exercisePoolId": _this.exercisePoolId}, (data) => {
                _this.exercisePoolName = data.ExercisePoolName;
                _this.exercisePoolExcount = data.ExerciseCount;
                _this.subjectCourse = data.SubjectCourse;
                _this.Genre = data.Genre
            });
        },
        //判断权限,能否编辑
        checkEditor: function () {
            let _this = this;
            tools.api('user.checkEditor', "", (data) => {
                if (data) {
                    _this.IsEditor = true;
                } else {
                    tools.api('ExercisesPool.CheckMyExercisePool', {"ExercisePoolID": _this.exercisePoolId}, (data) => {
                        if (data) {
                            _this.IsEditor = true;
                        } else {
                            _this.IsEditor = false;
                        }
                    });
                }
            });
        },
        //获取题库统计
        getPictureCountByExercisePool: function () {
            let _this = this;
            _this.reviewPictureTotalCount = 0;
            _this.reviewPictureCount = 0;
            _this.catalogPictureList = [];
            _this.catalogPictureActiveIndex = 0;
            _this.isImgAbnormal = false;
            _this.answerPictureList = [];
            _this.exercisePictureList = [];
            _this.repeatPageCount = 0;

            tools.api('OCR.SearchResourceByExercisePoolAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "orderBy": 0,
            }, (data) => {
                if (data && data.length > 0) {
                    //pictureStatus  图片标注状态：{0：未标注，1：已标注，2：未录入，3录入中，4已录入}
                    _this.reviewPictureTotalCount = data.length;
                    for (let item of data) {
                        let PictureItem = {};
                        PictureItem.page = item.PageNumber;
                        PictureItem.picture = item.ResourceId;
                        PictureItem.pictureUrl = tools.ConvertResourceUrl(item.ResourceId);
                        PictureItem.pictureStatus = item.MarkStatus;
                        PictureItem.pictureType = item.ResourceType;
                        PictureItem.IdentifyStatus = item.IdentifyStatus;
                        if (item.ResourceType == 0) {
                            _this.catalogPictureList.push(PictureItem);
                        }
                        if (item.ResourceType == 1) {
                            _this.exercisePictureList.push(PictureItem);
                        }
                        if (item.ResourceType == 2) {
                            _this.answerPictureList.push(PictureItem);
                        }
                        if (item.MarkStatus >= 1) {
                            _this.reviewPictureCount++;
                        }
                    }

                    //判断习题页页码重复
                    for (let exPicture of _this.exercisePictureList) {
                        let temp = _this.exercisePictureList.filter(item => {
                            return item.page == exPicture.page;
                        })
                        if (temp && temp.length >= 2 && exPicture.page != 0) {
                            exPicture.isRepeatPage = true;
                            _this.repeatPageCount++;
                        } else {
                            exPicture.isRepeatPage = false;
                        }
                    }

                    _this.imgAbnormal();
                }
            });
        },
        gotoExpoolPicture: function () {
            tools.deleteCookie("ExpoolActiveChapterId" + this.exercisePoolId);
            this.$router.push("/ocr/expoolPicture/" + this.exercisePoolId+'/'+this.jing+'/'+this.Statu);
        },

        //上一个目录图
        prevPicture: function () {
            this.catalogPictureActiveIndex = this.catalogPictureActiveIndex - 1;
            if (this.catalogPictureActiveIndex < 0) {
                this.catalogPictureActiveIndex = 0;
            }
            this.imgAbnormal();
        },
        //下一个目录图
        nextPicture: function () {
            this.catalogPictureActiveIndex = this.catalogPictureActiveIndex + 1;
            if (this.catalogPictureActiveIndex > this.catalogPictureList.length - 1) {
                this.catalogPictureActiveIndex = this.catalogPictureList.length - 1;
            }
            this.imgAbnormal();
        },

        //图片选框
        drawDeputy: function (e, resourceid) {
            const _this = this;
            var $this = e.target ? e.target : e;

            let $img = $this;
            let $imgBox = $($this).parent();
            //图片当前尺寸
            let imgSW = $img.width;
            let imgSH = $img.height;
            let imgSLeft = $img.offsetLeft;
            let imgSTop = $img.offsetTop;
            //图片原有尺寸
            var image = new Image();
            image.src = $($this).attr("src");
            let imgOW, imgOH;
            image.onload = function (e) {
                imgOW = image.width;
                imgOH = image.height;
            }

            $(".shadows").remove();
            // 生成截图效果结构
            const $shadows = $('<div class="shadows">' +
                '<div data-shadow="shadow1"></div>' +
                '<div data-shadow="shadow2"></div>' +
                '<div data-shadow="shadow3"></div>' +
                '<div data-shadow="shadow4"></div>' +
                '</div>')
            $imgBox.append($shadows);
            //box滚动距离
            // let imgBoxScroll = {
            //     x: $imgBox.scrollLeft(),
            //     y: $imgBox.scrollTop()
            // }
            // let left = imgSLeft - imgBoxScroll.x;
            // let top = imgSTop - imgBoxScroll.y;
            $shadows.get(0).setAttribute('style', 'width: ' + imgSW + 'px;height: ' + imgSH + 'px;left:' + imgSLeft + 'px;top:' + imgSTop + 'px');

            // // 滚动监听，重算shadows相关参数
            // //目录页图片放大出滚动条时，阴影shadows跟着移动，协助划词准确定位
            // $imgBox.off('scroll');
            // $imgBox.on('scroll', (e) => {
            //     //box滚动距离
            //     let imgBoxScroll = {
            //         x: $imgBox.scrollLeft(),
            //         y: $imgBox.scrollTop()
            //     }
            //     let left = imgSLeft - imgBoxScroll.x;
            //     let top = imgSTop - imgBoxScroll.y;
            //     $shadows.get(0).setAttribute('style', 'width: ' + imgSW + 'px;height: ' + imgSH + 'px;left:' + left + 'px;top:' + top + 'px');
            // })

            // 注册截图效果结构的事件
            $shadows.on('mousedown', (e) => {
                _this.imgAbnormal();
                if (_this.isImgAbnormal == true) {
                    _this.imgAbnormalModal();
                    return false;
                }

                let $target = $(e.target);
                if ($target.attr('data-shadow')) {
                    $target = $target.parent()
                }

                // shadow结构
                let $_shadow1 = $target.find('[data-shadow="shadow1"]')
                let $_shadow2 = $target.find('[data-shadow="shadow2"]')
                let $_shadow3 = $target.find('[data-shadow="shadow3"]')
                let $_shadow4 = $target.find('[data-shadow="shadow4"]')

                // 图片左上角坐标
                let imgPosition = {
                    x: $img.getBoundingClientRect().x,
                    y: $img.getBoundingClientRect().y
                }

                // 图片的宽高
                let imgBoxW = Math.round($img.getBoundingClientRect().width);
                let imgBoxH = Math.round($img.getBoundingClientRect().height);

                // 获取鼠标点击坐标
                let sp = {x: e.pageX, y: e.pageY};

                // 转换为相对于图片的坐标
                let downXY = getXY(sp.x, sp.y);

                // 清除样式
                removeAllAttr()

                // 设置遮罩位置
                $_shadow1.css('left', 0).css('top', 0).css('right', 0).css('bottom', imgBoxH - downXY.y)
                $_shadow2.css('left', 0).css('top', downXY.y).css('right', imgBoxW - downXY.x).css('bottom', imgBoxH - downXY.y)
                $_shadow3.css('left', downXY.x).css('top', downXY.y).css('right', 0).css('bottom', imgBoxH - downXY.y)
                $_shadow4.css('left', 0).css('top', downXY.y).css('right', 0).css('bottom', 0)

                let direction = 0

                $shadows.on('mousemove', (e) => {
                    // 获取鼠标点击坐标
                    let p = {x: e.pageX, y: e.pageY}
                    // 确定方向
                    direction = 0
                    // 转换为相对于图片的坐标
                    let downXY2 = getXY(p.x, p.y);
                    if (getAngleByX(sp, p) >= 0 && getAngleByX(sp, p) <= 90) {
                        //0 左上→右下
                        direction = 0
                        // 设置遮罩位置
                        $_shadow2.css('bottom', imgBoxH - downXY2.y)
                        $_shadow3.css('left', downXY2.x).css('bottom', imgBoxH - downXY2.y)
                        $_shadow4.css('top', downXY2.y)
                    } else if (getAngleByX(sp, p) > 90 && getAngleByX(sp, p) <= 180) {
                        //1 右上→左下
                        direction = 1
                        // 设置遮罩位置
                        $_shadow2.css('right', imgBoxW - downXY2.x).css('bottom', imgBoxH - downXY2.y)
                        $_shadow3.css('bottom', imgBoxH - downXY2.y)
                        $_shadow4.css('top', downXY2.y)
                    } else if (getAngleByX(sp, p) < 0 && getAngleByX(sp, p) > -90) {
                        //2 左下→右上
                        direction = 2
                        // 设置遮罩位置
                        $_shadow1.css('bottom', imgBoxH - downXY2.y)
                        $_shadow2.css('top', downXY2.y)
                        $_shadow3.css('left', downXY2.x).css('top', downXY2.y)
                    } else if (getAngleByX(sp, p) >= -180 && getAngleByX(sp, p) <= -90) {
                        //3 右下→左上
                        direction = 3
                        // 设置遮罩位置
                        $_shadow1.css('bottom', imgBoxH - downXY2.y)
                        $_shadow2.css('top', downXY2.y).css('right', imgBoxW - downXY2.x)
                        $_shadow3.css('top', downXY2.y)
                    }

                })

                $shadows.on('mouseup', (e) => {
                    // 获取鼠标点击坐标
                    let p = {x: e.pageX, y: e.pageY}

                    // 转换为相对于图片的坐标
                    let upXY = getXY(p.x, p.y)

                    console.log('按下坐标', downXY)
                    console.log('抬起坐标', upXY)

                    let sxy = ''
                    let exy = ''
                    switch (direction) {
                        //0 左上→右下
                        case 0: {
                            sxy = downXY
                            exy = upXY
                            break
                        }
                        //1 右上→左下
                        case 1: {
                            sxy = {
                                x: upXY.x,
                                y: downXY.y
                            }
                            exy = {
                                x: downXY.x,
                                y: upXY.y
                            }
                            break
                        }
                        //2 左下→右上
                        case 2: {
                            sxy = {
                                x: downXY.x,
                                y: upXY.y
                            }
                            exy = {
                                x: upXY.x,
                                y: downXY.y
                            }
                            break
                        }
                        //3 右下→左上
                        case 3: {
                            sxy = upXY
                            exy = downXY
                            break
                        }
                    }

                    // 转换为原图大小的坐标
                    // ocr接口参数
                    let scope = {
                        leftTop: {x: 0, y: 0},
                        rightBottom: {x: 0, y: 0}
                    }
                    scope.leftTop.x = sxy.x / imgBoxW * imgOW;
                    scope.leftTop.y = sxy.y / imgBoxH * imgOH;
                    scope.rightBottom.x = exy.x / imgBoxW * imgOW;
                    scope.rightBottom.y = exy.y / imgBoxH * imgOH;

                    // 注销
                    $shadows.off('mousemove')
                    $shadows.off('mouseup')

                    _this.getWordByImgRegion(resourceid, parseInt(scope.leftTop.x) + ',' + parseInt(scope.leftTop.y), parseInt(scope.rightBottom.x) + ',' + parseInt(scope.rightBottom.y));
                })

                /**
                 * 转换坐标，相对图片
                 * @param x
                 * @param y
                 * @returns {{x: number, y: number}}
                 */
                function getXY(x, y) {
                    let xy = {x: 0, y: 0}

                    //四舍五入 取绝对值
                    xy.x = Math.round(Math.abs(x - imgPosition.x))
                    xy.y = Math.round(Math.abs(y - imgPosition.y))

                    return xy
                }

                /**
                 * 清除所有遮罩的样式
                 */
                function removeAllAttr() {
                    for (let oneChild of document.body.querySelectorAll('[data-shadow]')) {
                        oneChild.removeAttribute('style')
                    }
                }

                /**
                 * 计算两点连线，和X轴的夹角
                 * @param point1
                 * @param point2
                 * @returns {number}
                 */
                function getAngleByX(point1, point2) {
                    return Math.round(Math.atan2((point2.y - point1.y), (point2.x - point1.x)) / Math.PI * 180)
                }
            })
        },
        //获取选取的文字
        getWordByImgRegion: function (resourceid, leftup, rightdown) {
            let _this = this;
            tools.ajaxRequest(
                tools._exerciseocr + "getWordByPoint" + '?ssotoken=' + token,
                "GET",
                {
                    "resourceid": resourceid,
                    "leftup": leftup,
                    "rightdown": rightdown,
                    "type": 0 //0=目录
                },
                function (data) {
                    if (data) {
                        //补全章下的页码
                        for (let i in data) {
                            i = parseInt(i);
                            if (data[i].level == 0 && data[i].page == "" && data[i + 1] && data[i + 1].level == 1) {
                                data[i].page = data[i + 1].page;
                            }
                        }
                        _this.$refs.chapterComponents.setCatalogValue(data);
                        window.burryPointHandler({
                            "data": data
                        }, 'UCT2_4_1')
                    }
                }
            );
        },

        //======章节下图片的操作==========
        getChapterPicture: function (echapterIds) {
            let _this = this;
            _this.chapterPictureList = [];
            _this.chapterPictureActiveIndex = 0;
            _this.isImgAbnormal = false;
            _this.selectChapterPictureList = [];

            tools.api('OCR.SearchResourceByExercisePoolAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "orderBy": 0,
                "echapterIds": echapterIds,
            }, (data) => {
                if (data) {
                    let PictureList = [];
                    for (let item of data) {
                        //章节只看习题页
                        if (item.ResourceType == 1) {
                            let PictureItem = {};
                            PictureItem.page = item.PageNumber;
                            PictureItem.picture = item.ResourceId;
                            PictureItem.pictureUrl = tools.ConvertResourceUrl(item.ResourceId);
                            PictureItem.pictureStatus = item.MarkStatus;
                            PictureItem.pictureType = item.ResourceType;
                            PictureItem.exerciseCount = item.ExerciseCount;
                            PictureItem.IdentifyStatus = item.IdentifyStatus;
                            PictureList.push(PictureItem);
                        }
                    }
                    _this.chapterPictureList = PictureList;
                    _this.imgAbnormal();
                }

                if (_this.chapterPictureList.length <= 0) {
                    _this.isNothing = true;
                } else {
                    _this.isNothing = false;
                }
            });
        },
        //上一个章节图
        prevChapterPicture: function () {
            this.chapterPictureActiveIndex = this.chapterPictureActiveIndex - 1;
            if (this.chapterPictureActiveIndex < 0) {
                this.chapterPictureActiveIndex = 0;
            }
            this.imgAbnormal();
        },
        //下一个章节图
        nextChapterPicture: function () {
            this.chapterPictureActiveIndex = this.chapterPictureActiveIndex + 1;
            if (this.chapterPictureActiveIndex > this.chapterPictureActiveIndex.length - 1) {
                this.chapterPictureActiveIndex = this.chapterPictureActiveIndex.length - 1;
            }
            this.imgAbnormal();
        },
        //当前一个章节图
        indexChapterPicture: function (index) {
            this.chapterPictureActiveIndex = index;
            this.imgAbnormal();
        },
        //删除章下图片
        delChapterPicture: function (picture) {
            let _this = this;
            tools.alertconfim("请确认是否移除该页", '', function () {
                let json = {
                    'resourceId': picture,
                    'eChapterId': _this.activeChapterId
                };
                _this.delChapterPictureCommon([json]);
            });
            window.burryPointHandler({
                'resourceId': picture,
                'eChapterId': _this.activeChapterId
            }, 'UCT2_4_7')
        },
        //删除图片章节公共方法
        delChapterPictureCommon: function (jsonList) {
            let _this = this;
            tools.api('OCR.RemoveEChapterResourceAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "resourceList": jsonList
            }, (data) => {
                _this.getChapterPicture(_this.activeChapterId);
            });
        },
        //选择章下图片
        selectChapterPicture: function (picture) {
            let _this = this;
            if (_this.selectChapterPictureList.indexOf(picture) > -1) {
                _this.selectChapterPictureList = _this.selectChapterPictureList.filter(function (item) {
                    return item != picture;
                })
            } else {
                _this.selectChapterPictureList.push(picture);
            }
        },
        //添加章下图片
        addChapterPicture: function () {
            let _this = this;
            if (_this.selectChapterPictureList.length <= 0) {
                return false;
            }
            let jsonList = [];
            for (let item of _this.selectChapterPictureList) {
                jsonList.push({
                    'resourceId': item,
                    'eChapterId': _this.activeChapterId
                })
            }
            window.burryPointHandler(
                {
                    'jsonList': jsonList
                },
                'UCT2_4_6'
            )
            _this.modifyPictureChapterCommon(jsonList);
        },
        //修改图片章节公共方法
        modifyPictureChapterCommon: function (jsonList) {
            let _this = this;
            tools.api('OCR.SaveEChapterResourceAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "resourceList": jsonList
            }, (data) => {
                _this.getChapterPicture(_this.activeChapterId);
            });
        },

        changeChapterViewType: function (index) {
            window.burryPointHandler({chapterViewType: index}, 'UCT2_4_8')
            this.isNothing = false;
            this.chapterViewType = index;
            this.chapterViewTypeCommon();
        },
        //切换章下视图的公共方法
        chapterViewTypeCommon: function () {
            let _this = this;
            if (_this.chapterViewType == 0) {
                //章id需要传所有子节点id
                let activeChapterIdList = _this.$refs.chapterComponents.getSubChapterList(_this.activeChapterId);

                _this.getChapterPicture(_this.activeChapterId);
            } else if (_this.chapterViewType == 1) {
                //查看习题，章id需要传所有子节点id
                let activeChapterIdList = _this.$refs.chapterComponents.getSubChapterList(_this.activeChapterId);

                _this.$nextTick(() => {
                    _this.$refs.expoolExercise.init(_this.activeChapterId,activeChapterIdList.join(","));
                })
            }
        },
        closeExpoolExercise: function (chapterViewType) {
            window.burryPointHandler({'chapterViewType': chapterViewType }, 'UCT2_5_1')
            this.chapterViewType = chapterViewType;
            this.chapterViewTypeCommon();
        },

        //创建习题
        gotoCreateExercise: function (picture, isNewEdition, isNewentry = false) {
            window.burryPointHandler({'cmsid' :picture, 'isNewEdition':  isNewEdition}, 'UCT2_4_10')
            let _this = this;
            let href = "";
            if (isNewEdition) {
                //文科
                //https://artsentryexe.hexfuture.net/index.html#type=chief&mode=ocr&cmsid=2585629331338&expoolid=3027952048249&chapterid=3027952075786

                if(_this.jing==3||_this.jing==5){
                    href = tools._exerciseInput_arts + "index.html#type=chief&version=bph&mode=ocr&cmsid=" + picture + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.activeChapterId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                }else{
                    href = tools._exerciseInput_arts + "index.html#type=chief&mode=ocr&cmsid=" + picture + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.activeChapterId + '&isFromExpool=true' + '&subjectCourse=' + _this.subjectCourse;
                }
            } else {
                //理科 弃用
                // https://entryexe.hexfuture.net/index.html#type=chief&cmsid=2585627248597&expoolid=3027952024611
                href = tools._exerciseInput + "index.html#type=chief&cmsid=" + picture + "&expoolid=" + _this.exercisePoolId + "&chapterid=" + _this.activeChapterId;
            }

            if (isNewentry) {
                href = href.replace('index.html', 'newentry.html')
            }
            tools.OpenHref(href, "_blank");
        },

        //图片异常提示
        imgAbnormal: function () {
            let _this = this;
            let one = "";
            if (_this.activeChapterId == 0) {
                //目录图
                one = _this.catalogPictureList[_this.catalogPictureActiveIndex];
            } else {
                //章节图
                one = _this.chapterPictureList[_this.chapterPictureActiveIndex];
            }
            if (one && one.IdentifyStatus == 1) {
                _this.isImgAbnormal = true;
            } else {
                _this.isImgAbnormal = false;
            }
        },
        imgAbnormalModal: function () {
            let _this = this
            this.isShowImgAbnormalModal = true;
            clearTimeout(this.imgAbnormalModalTimeout);
            this.imgAbnormalModalTimeout = setTimeout(function () {
                _this.isShowImgAbnormalModal = false;
            }, 2000)
        },
        //图片放大
        changeEnlargeIndex: function (index) {
            window.burryPointHandler({'enLarge': this.enlargeList[index]}, 'UCT2_4_9')
            let _this = this

            _this.enlargeIndex = index;
            _this.isEditorCatalog = _this.$refs.chapterComponents.getIsEditorCatalog();
            if (_this.isEditorCatalog) {
                _this.$nextTick(function () {
                    let resourceid = _this.catalogPictureList[_this.catalogPictureActiveIndex].picture;
                    _this.drawDeputy($(".imgbox>img").get(0), resourceid);
                })
            }
        },

        //=========与Chapter组件交互start===========
        //章节
        changeChapterComponents: function (activeChapterId,activeChapterName) {
            let _this = this;
            _this.activeChapterId = activeChapterId;
            _this.activeChapterName = activeChapterName;
            _this.isImgAbnormal = false;
            if (_this.activeChapterId == 0) {
                //目录
                if (_this.catalogPictureList.length <= 0) {
                    _this.isNothing = true;
                } else {
                    _this.isNothing = false;
                }
            } else {
                //章节
                $(".shadows").remove();
                _this.chapterViewTypeCommon();
            }
        },
        //编辑状态
        changeEditorCatalogComponents: function (isEditorCatalog) {
            let _this = this;
            _this.isEditorCatalog = isEditorCatalog;
        },
        //=========与Chapter组件交互end===========
        //搜索
        searchexp:function(){
            window.burryPointHandler({'serachTxt':this.serachTxt} , 'UCT2_4_5')
            this.isSearch = true
            let _this = this;
            setTimeout(()=>{
                _this.gosearch();
            },500)
        },
        gosearch(){
            this.$refs.searchexpoolExercise.init(-1,-1,this.serachTxt);
        },
        backlist:function(){
            this.isSearch = false
        },
        showallVoice(id){

            this.nowchiceChapter = id
            this.voiceareashow = true;
            let _this = this;
            tools.api('ExercisesPool.SeachAttacheFiledListByExercisePoolID', {
                exercisePoolId:_this.exercisePoolId,
            }, (data) => {
                if (data) {
                    _this.allvoiceList=data
                }
            });
        },
        changevoice(){
            let _this = this;
            tools.api('ExercisesPool.InsertEChapterAndResource', {
                echapterId:_this.nowchiceChapter,
                resourceId:[_this.voiceid]
            }, (data) => {
                if (data) {
                    _this.$message({
                        message: '添加关联成功',
                        type: 'success'
                    });
                    _this.voiceareashow=false;

                }
            });
        },
        closedig(){
            this.voiceareashow = false;
            this.allvoiceList = [];
        },
        delvoice(activeChapterId,linkvoiceId){
            this.activeChapterId=activeChapterId
            this.linkvoiceId=linkvoiceId
            this.dialogVisible = true
        },
        delvoicebtn(){
            let _this = this;
            tools.api('ExercisesPool.DeleteEChapterAndResource', {
                echapterId:_this.activeChapterId,
                resourceId:_this.linkvoiceId
            }, (data) => {
                this.dialogVisible = false
                // _this.$message({
                //     message: '解除关联成功',
                //     type: 'success'
                // });
            });
        }
    }
}
